import * as React from "react";
import { Text, Box, StackProps, TextProps } from "@chakra-ui/react";

import Stack from "components/Chakra/ResponsiveStack";
import BaseRadio from "./BaseRadio";

interface IProps extends StackProps {
  onClick: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  isActive?: boolean;
  text: string;
  justify?: StackProps["justify"];
  textFontWidth?: TextProps["fontWeight"];
  textHoverColor?: TextProps["color"];
}

const RadioWithText: React.FC<IProps> = ({
  isActive = false,
  justify = "center",
  textFontWidth = "normal",
  textHoverColor = "dark",
  onClick,
  onKeyDown,
  text,
  ...props
}) => {
  const [hover, setHover] = React.useState(false);

  return (
    <Stack
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onKeyDown={(e) => onKeyDown && onKeyDown(e)}
      {...props}
    >
      <Stack direction="row" cursor="pointer" justify={justify} spacing="0">
        <Box pr={1.5}>
          <BaseRadio isActive={isActive} externalHover={hover} />
        </Box>
        <Text
          fontWeight={textFontWidth}
          _hover={{ color: textHoverColor }}
          color={hover ? textHoverColor : "dark"}
        >
          {text}
        </Text>
      </Stack>
    </Stack>
  );
};

export default RadioWithText;
